/* ==========================================================================
   Hazy Grove Interactions
   Deferred JS for behaviors the static mockups couldn't show
   ========================================================================== */

/* --------------------------------------------------------------------------
   Age Gate
   -------------------------------------------------------------------------- */

function initAgeGate() {
  var gate = document.querySelector('.hg-age-gate');
  if (!gate) return;

  if (localStorage.getItem('ageVerified') === 'true') {
    gate.remove();
    return;
  }

  gate.style.display = 'flex';
  document.body.style.overflow = 'hidden';

  // Trap focus inside the age gate
  var focusableEls = gate.querySelectorAll('button, [tabindex]:not([tabindex="-1"])');
  var firstFocusable = focusableEls[0];
  var lastFocusable = focusableEls[focusableEls.length - 1];

  if (firstFocusable) firstFocusable.focus();

  gate.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    if (e.shiftKey) {
      if (document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      }
    } else {
      if (document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    }
  });

  var yesBtn = gate.querySelector('.hg-age-gate__btn--yes');
  var noBtn = gate.querySelector('.hg-age-gate__btn--no');

  if (yesBtn) {
    yesBtn.addEventListener('click', function () {
      localStorage.setItem('ageVerified', 'true');
      document.body.style.overflow = '';
      gate.classList.add('hiding');
      gate.addEventListener('transitionend', function () {
        gate.remove();
      }, { once: true });
    });
  }

  if (noBtn) {
    noBtn.addEventListener('click', function () {
      window.location.href = 'https://www.google.com';
    });
  }
}

/* --------------------------------------------------------------------------
   FAQ Category Filter
   -------------------------------------------------------------------------- */

function initFaqFilter() {
  var pills = document.querySelectorAll('.hg-faq-pill');
  var sections = document.querySelectorAll('.hg-faq-section[data-category]');

  if (!pills.length || !sections.length) return;

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      var category = this.getAttribute('data-filter');

      // Update active pill
      pills.forEach(function (p) { p.classList.remove('active'); });
      this.classList.add('active');

      // Show/hide sections
      sections.forEach(function (section) {
        if (category === 'all' || section.getAttribute('data-category') === category) {
          section.classList.remove('hidden');
        } else {
          section.classList.add('hidden');
        }
      });
    });
  });
}

/* --------------------------------------------------------------------------
   FAQ Accordion
   -------------------------------------------------------------------------- */

function initFaqAccordion() {
  document.querySelectorAll('.hg-faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.hg-faq-item');
      var wasOpen = item.classList.contains('open');

      // Close all items in same section
      var section = item.closest('.hg-faq-section');
      if (section) {
        section.querySelectorAll('.hg-faq-item.open').forEach(function (el) {
          el.classList.remove('open');
          el.querySelector('.hg-faq-question').setAttribute('aria-expanded', 'false');
        });
      }

      // Toggle clicked item
      if (!wasOpen) {
        item.classList.add('open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

/* --------------------------------------------------------------------------
   Scroll-Triggered Section Animations
   -------------------------------------------------------------------------- */

function initScrollAnimations() {
  // Respect reduced-motion preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var sections = document.querySelectorAll('.hg-section');
  if (!sections.length) return;

  // Failsafe: never leave sections stuck at opacity:0 if IntersectionObserver is missing.
  if (!('IntersectionObserver' in window)) {
    sections.forEach(function (el) { el.classList.add('hg-animate'); });
    return;
  }

  // threshold:0 reveals a section as soon as ANY part enters the viewport. A 0.1 threshold
  // meant sections taller than ~10x the viewport (e.g. the Shop All variant grid) never
  // reached that ratio at the top of the page, so they stayed invisible until a scroll
  // nudged the observer. With 0, in-view sections (incl. tall ones) reveal on load.
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('hg-animate');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0 });

  sections.forEach(function (el) {
    observer.observe(el);
  });
}

/* --------------------------------------------------------------------------
   Interactive Video Timeline
   -------------------------------------------------------------------------- */

function initVideoTimeline() {
  var container = document.querySelector('.hg-timeline-v2');
  if (!container) return;

  var dots = container.querySelectorAll('.hg-timeline-v2__dot');
  var videos = container.querySelectorAll('.hg-timeline-v2__video');
  var contents = container.querySelectorAll('.hg-timeline-v2__content');
  var trackFill = container.querySelector('.hg-timeline-v2__track-fill');
  var currentStep = 0;

  function goToStep(index) {
    if (index === currentStep) return;

    // Deactivate old
    if (videos[currentStep]) videos[currentStep].classList.remove('active');
    if (contents[currentStep]) contents[currentStep].classList.remove('active');

    // Update all dots: active, visited, or default
    dots.forEach(function (dot, i) {
      dot.classList.remove('active', 'visited');
      if (i === index) {
        dot.classList.add('active');
      } else if (i < index) {
        dot.classList.add('visited');
      }
    });

    currentStep = index;

    // Activate new
    if (videos[currentStep]) {
      videos[currentStep].classList.add('active');
      videos[currentStep].currentTime = 0;
      videos[currentStep].play().catch(function () {});
    }
    if (contents[currentStep]) contents[currentStep].classList.add('active');

    // Update progress track
    var progress = dots.length > 1 ? (currentStep / (dots.length - 1)) * 100 : 0;
    if (trackFill) trackFill.style.width = progress + '%';
  }

  // Bind clicks
  dots.forEach(function (dot, index) {
    dot.addEventListener('click', function () {
      goToStep(index);
    });
  });

  // Start first video
  if (videos.length > 0 && videos[0]) {
    videos[0].play().catch(function () {});
  }
}

/* --------------------------------------------------------------------------
   Lightbox
   -------------------------------------------------------------------------- */

function initLightbox() {
  if (document.getElementById('hgLb4')) return;
  console.log('[HG] Lightbox v4 init');

  // Helper: set multiple inline !important styles
  function S(el, props) {
    for (var k in props) el.style.setProperty(k, props[k], 'important');
  }

  try {
    var wrap = document.createElement('div');
    wrap.id = 'hgLb4';
    S(wrap, {
      position: 'fixed', top: '0', left: '0', width: '100vw', height: '100vh',
      'z-index': '99999', display: 'none', 'align-items': 'center',
      'justify-content': 'center', margin: '0', padding: '0',
      'background-color': 'rgba(0,0,0,0.85)',
      'backdrop-filter': 'blur(12px)', '-webkit-backdrop-filter': 'blur(12px)'
    });

    var img = document.createElement('img');
    S(img, {
      position: 'relative', 'z-index': '1', 'max-width': '90vw', 'max-height': '85vh',
      'object-fit': 'contain', 'border-radius': '4px', display: 'block',
      'background-color': 'transparent'
    });
    wrap.appendChild(img);

    var btnClose = document.createElement('span');
    btnClose.textContent = '\u00D7';
    S(btnClose, {
      position: 'absolute', 'z-index': '2', top: '16px', right: '20px',
      color: 'rgba(255,255,255,0.9)', 'font-size': '44px', 'line-height': '1',
      cursor: 'pointer', 'background-color': 'transparent', border: 'none', padding: '12px',
      'font-family': 'system-ui, sans-serif'
    });
    wrap.appendChild(btnClose);

    var btnPrev = document.createElement('span');
    btnPrev.textContent = '<';
    S(btnPrev, {
      position: 'absolute', 'z-index': '2', top: '50%', left: '16px',
      transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.9)',
      'font-size': '48px', 'line-height': '1', cursor: 'pointer',
      'background-color': 'transparent', border: 'none', padding: '16px',
      'font-family': 'system-ui, sans-serif', 'font-weight': '300',
      'user-select': 'none', '-webkit-user-select': 'none'
    });
    wrap.appendChild(btnPrev);

    var btnNext = document.createElement('span');
    btnNext.textContent = '>';
    S(btnNext, {
      position: 'absolute', 'z-index': '2', top: '50%', right: '16px',
      transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.9)',
      'font-size': '48px', 'line-height': '1', cursor: 'pointer',
      'background-color': 'transparent', border: 'none', padding: '16px',
      'font-family': 'system-ui, sans-serif', 'font-weight': '300',
      'user-select': 'none', '-webkit-user-select': 'none'
    });
    wrap.appendChild(btnNext);

    var counter = document.createElement('div');
    S(counter, {
      position: 'absolute', 'z-index': '2', bottom: '18px', left: '50%',
      transform: 'translateX(-50%)', color: 'rgba(255,255,255,0.7)',
      'font-size': '14px', 'font-family': 'system-ui, sans-serif', 'background-color': 'transparent'
    });
    wrap.appendChild(counter);

    document.body.appendChild(wrap);
    console.log('[HG] LB appended, children:', wrap.children.length, 'in DOM:', !!document.getElementById('hgLb4'));
  } catch (err) {
    console.error('[HG] LB create error:', err);
    return;
  }

  var images = [];
  var currentIndex = 0;
  var isOpen = false;

  function open(group, index) {
    console.log('[HG] LB open:', group, 'idx:', index);
    var items = document.querySelectorAll('[data-hg-lightbox-group="' + group + '"]');
    images = [];
    items.forEach(function (el) {
      images.push({
        src: el.getAttribute('data-hg-lightbox-src'),
        alt: (el.querySelector('img') || {}).alt || ''
      });
    });
    if (!images.length) return;
    currentIndex = index;
    show();
    wrap.style.setProperty('display', 'flex', 'important');
    document.body.style.overflow = 'hidden';
    isOpen = true;
  }

  function close() {
    wrap.style.setProperty('display', 'none', 'important');
    document.body.style.overflow = '';
    isOpen = false;
  }

  function show() {
    img.style.setProperty('opacity', '0.3', 'important');
    img.src = images[currentIndex].src;
    img.alt = images[currentIndex].alt;
    counter.textContent = (currentIndex + 1) + ' / ' + images.length;
    btnPrev.style.setProperty('display', images.length > 1 ? 'block' : 'none', 'important');
    btnNext.style.setProperty('display', images.length > 1 ? 'block' : 'none', 'important');
    if (images[currentIndex + 1]) new Image().src = images[currentIndex + 1].src;
    if (images[currentIndex - 1]) new Image().src = images[currentIndex - 1].src;
  }

  function prev() { currentIndex = (currentIndex - 1 + images.length) % images.length; show(); }
  function next() { currentIndex = (currentIndex + 1) % images.length; show(); }

  img.addEventListener('load', function () { img.style.setProperty('opacity', '1', 'important'); });
  btnClose.addEventListener('click', function (e) { e.stopPropagation(); close(); });
  wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
  btnPrev.addEventListener('click', function (e) { e.stopPropagation(); prev(); });
  btnNext.addEventListener('click', function (e) { e.stopPropagation(); next(); });

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') prev();
    if (e.key === 'ArrowRight') next();
  });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-hg-lightbox-src]');
    if (!trigger) return;
    var group = trigger.getAttribute('data-hg-lightbox-group');
    if (!group) return;
    var siblings = document.querySelectorAll('[data-hg-lightbox-group="' + group + '"]');
    var idx = Array.prototype.indexOf.call(siblings, trigger);
    open(group, idx >= 0 ? idx : 0);
  });
}

/* --------------------------------------------------------------------------
   Hero Slideshow (crossfade carousel)
   -------------------------------------------------------------------------- */

function initHeroSlideshow() {
  var heroes = document.querySelectorAll('[data-hg-hero]');
  if (!heroes.length) return;

  heroes.forEach(function (hero) {
    // Guard against double-init (DOMContentLoaded + shopify:section:load)
    if (hero.getAttribute('data-hg-hero-init') === 'true') return;
    hero.setAttribute('data-hg-hero-init', 'true');

    var slides = hero.querySelectorAll('[data-hg-slide]');
    if (slides.length <= 1) return; // single slide is static — no controls or timer

    var dots = hero.querySelectorAll('[data-hg-dot]');
    var prevBtn = hero.querySelector('[data-hg-prev]');
    var nextBtn = hero.querySelector('[data-hg-next]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = hero.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    var interval = parseInt(hero.getAttribute('data-interval'), 10) || 6000;

    var current = 0;
    var timer = null;
    var hovered = false;
    var focused = false;
    var editorSelected = false;

    function canPlay() {
      return autoplay && !hovered && !focused && !editorSelected && !document.hidden;
    }

    function setSlide(index) {
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('aria-hidden');
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('inert', '');
        }
      });
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      current = index;
    }

    function goTo(index) {
      var count = slides.length;
      setSlide(((index % count) + count) % count);
    }
    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function start() {
      stop();
      if (canPlay()) timer = setInterval(next, interval);
    }

    // Manual navigation advances and resets the autoplay countdown
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); start(); });
    });

    // Keyboard navigation when focus is within the hero
    hero.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { prev(); start(); }
      else if (e.key === 'ArrowRight') { next(); start(); }
    });

    // Pause on hover and on keyboard focus within the hero
    hero.addEventListener('mouseenter', function () { hovered = true; stop(); });
    hero.addEventListener('mouseleave', function () { hovered = false; start(); });
    hero.addEventListener('focusin', function () { focused = true; stop(); });
    hero.addEventListener('focusout', function (e) {
      if (!hero.contains(e.relatedTarget)) { focused = false; start(); }
    });

    // Pause while the tab is hidden
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    // Theme editor: pause while selected, and clear the timer on re-render
    document.addEventListener('shopify:section:select', function (e) {
      if (e.target && e.target.contains(hero)) { editorSelected = true; stop(); }
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.target && e.target.contains(hero)) { editorSelected = false; start(); }
    });
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target && e.target.contains(hero)) stop();
    });

    setSlide(0);
    start();
  });
}

/* --------------------------------------------------------------------------
   Init
   -------------------------------------------------------------------------- */

document.addEventListener('DOMContentLoaded', function () {
  initAgeGate();
  initFaqFilter();
  initFaqAccordion();
  initScrollAnimations();
  initVideoTimeline();
  initLightbox();
  initHeroSlideshow();
});

// Support theme editor section reload
document.addEventListener('shopify:section:load', function () {
  initFaqFilter();
  initFaqAccordion();
  initVideoTimeline();
  initHeroSlideshow();
});
